export enum CONTRACTOR_CODE_TYPE_ENUM {
  none = 0,
  sabre = 1,
  worldspan = 2,
  amadeus = 3,
  galileo = 4,
  tripnet = 5,
  lowcost = 6,
  hrs = 7,
  horse21 = 8,
  pkp = 9,
  cta = 26,
}
